import { TableBody, TableCell, TableRow, Paper, Box, Link } from '@mui/material'
import EnhancedTable from '@common/components/Table/EnhancedTable'
import { FilterReportTypeSchema, ReportSchema } from '@common/config/api/client'
import { HeadCell } from '@common/components/Table/table.types'
import { useReportActions } from './hooks'
import { SPACING } from '@common/theme/spacing'

interface Props {
  reportType: FilterReportTypeSchema
}

type ReportTableSchema = ReportSchema & {
  actions: never
}

const headCells: readonly HeadCell<ReportTableSchema>[] = [
  { id: 'name', label: 'Report name', disablePadding: false },
  { id: 'actions', label: 'Actions', disablePadding: false },
] as const

export default function ReportTable({ reportType }: Props) {
  const { reports, isLoading, handleDownload, isDownloading } = useReportActions(reportType)

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <Box component="section">
      <Paper sx={{ p: SPACING.paperInnerPadding }}>
        <EnhancedTable<ReportTableSchema>
          rows={reports}
          headCells={headCells}
          order="asc"
          orderBy="name"
          selected={[]}
          page={0}
          rowsPerPage={50}
          onRequestSort={() => {}}
          onChangePage={() => {}}
          onChangeRowsPerPage={() => {}}
        >
          <TableBody>
            {reports.map((report) => (
              <TableRow hover key={report.name}>
                <TableCell>{report.name}</TableCell>
                <TableCell>
                  <Link
                    component="button"
                    onClick={() => handleDownload(report)}
                    disabled={isDownloading}
                    sx={{ textDecoration: 'none', cursor: 'pointer' }}
                  >
                    Download
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </EnhancedTable>
      </Paper>
    </Box>
  )
}
